import React, { useState, useEffect } from 'react';

const EnhancedPagination = ({ 
  currentPage, 
  totalPages, 
  onPageChange, 
  totalItems, 
  itemsPerPage,
  showInfo = true,
  className = ""
}) => {
  const [pageGroup, setPageGroup] = useState(0);

  // تحديث pageGroup عند تغيير الصفحة
  useEffect(() => {
    if (totalPages > 0) {
      const pagesPerGroup = Math.max(1, Math.ceil(totalPages / 2));
      const newPageGroup = Math.floor((currentPage - 1) / pagesPerGroup);
      setPageGroup(newPageGroup);
    }
  }, [currentPage, totalPages]);

  const handlePageChange = (page) => {
    if (page !== currentPage) {
      onPageChange(page);
      
      // تحديث pageGroup بناءً على الصفحة المختارة
      const pagesPerGroup = Math.max(1, Math.ceil(totalPages / 2));
      const newPageGroup = Math.floor((page - 1) / pagesPerGroup);
      setPageGroup(newPageGroup);
    }
  };

  if (totalPages <= 0) return null;

  const renderPagination = () => {
    const pages = [];
    const pagesPerGroup = Math.max(1, Math.ceil(totalPages / 2));
    
    // حساب نطاق الصفحات المعروضة
    const startPage = (pageGroup * pagesPerGroup) + 1;
    const endPage = Math.min(startPage + pagesPerGroup - 1, totalPages);
    const maxGroup = Math.ceil(totalPages / pagesPerGroup) - 1;
    
    
    // إضافة نقاط إذا كانت هناك مجموعة سابقة
    if (pageGroup > 0) {
      pages.push(
        <li key="dots-prev" className="page-item disabled">
          <span className="page-link" style={{ border: 'none', background: 'transparent' }}>...</span>
        </li>
      );
    }
    
    // عرض الصفحات في المجموعة الحالية
    for (let page = startPage; page <= endPage; page++) {
      pages.push(
        <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
          <button
            className="page-link"
            onClick={() => handlePageChange(page)}
            style={{
              backgroundColor: currentPage === page ? '#184194' : 'transparent',
              color: currentPage === page ? 'white' : '#184194',
              border: '1px solid #184194',
              minWidth: '35px',
              fontSize: '12px'
            }}
          >
            {page}
          </button>
        </li>
      );
    }
    
    // إذا لم تكن هناك صفحات، أضف الصفحة الحالية على الأقل
    if (pages.length === 0 && totalPages > 0) {
      pages.push(
        <li key={currentPage} className="page-item active">
          <button
            className="page-link"
            onClick={() => handlePageChange(currentPage)}
            style={{
              backgroundColor: '#184194',
              color: 'white',
              border: '1px solid #184194',
              minWidth: '35px',
              fontSize: '12px'
            }}
          >
            {currentPage}
          </button>
        </li>
      );
    }
    
    // إضافة نقاط إذا كانت هناك مجموعة تالية
    if (pageGroup < maxGroup) {
      pages.push(
        <li key="dots-next" className="page-item disabled">
          <span className="page-link" style={{ border: 'none', background: 'transparent' }}>...</span>
        </li>
      );
    }
    
    return pages;
  };

  return (
    <div className={`d-flex flex-column align-items-center ${className}`}>
      <nav aria-label="Page navigation">
        <ul className="pagination pagination-sm mb-0 flex-wrap justify-content-center">
          
          {/* زر أول صفحة */}
          <li className={`page-item ${currentPage <= 1 ? 'disabled' : ''}`}>
            <button
              className="page-link"
              onClick={() => handlePageChange(1)}
              disabled={currentPage <= 1}
              style={{ 
                color: '#184194',
                minWidth: '60px',
                fontSize: '12px'
              }}
            >
              <span className="d-none d-sm-inline">أول صفحة</span>
              <span className="d-inline d-sm-none">«</span>
            </button>
          </li>
          
          {/* زر الصفحة السابقة */}
          <li className={`page-item ${currentPage <= 1 ? 'disabled' : ''}`}>
            <button
              className="page-link"
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage <= 1}
              style={{ 
                color: '#184194',
                minWidth: '60px',
                fontSize: '12px'
              }}
            >
              <span className="d-none d-sm-inline">السابق</span>
              <span className="d-inline d-sm-none">‹</span>
            </button>
          </li>

          {/* أرقام الصفحات */}
          {renderPagination()}
          
          {/* زر الصفحة التالية */}
          <li className={`page-item ${currentPage >= totalPages ? 'disabled' : ''}`}>
            <button
              className="page-link"
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage >= totalPages}
              style={{ 
                color: '#184194',
                minWidth: '60px',
                fontSize: '12px'
              }}
            >
              <span className="d-none d-sm-inline">التالي</span>
              <span className="d-inline d-sm-none">›</span>
            </button>
          </li>
          
          {/* زر آخر صفحة */}
          <li className={`page-item ${currentPage >= totalPages ? 'disabled' : ''}`}>
            <button
              className="page-link"
              onClick={() => handlePageChange(totalPages)}
              disabled={currentPage >= totalPages}
              style={{ 
                color: '#184194',
                minWidth: '60px',
                fontSize: '12px'
              }}
            >
              <span className="d-none d-sm-inline">آخر صفحة</span>
              <span className="d-inline d-sm-none">»</span>
            </button>
          </li>

        </ul>
      </nav>
    </div>
  );
};

export default EnhancedPagination;
